import { css } from '@emotion/react'

export const HintStyle = css`

    
    background: #FFF;
    border-left: 5px solid;
    border-radius: 2px;
    padding: 1em 1em 1.2em;
    margin: 1em 0;
    display: flex;
    

    &.hint-danger {
        border-color: #ff4642;
        background: #f7f5f9;
        box-shadow: #ccb5b7 0px 4px 10px -2px,#00000005 0 -2px 5px 0px;
    }
    &.hint-warning {
        border-color: #f77d05;
        background: #f7f5f9;
        box-shadow: #bfbeb9 0px 4px 10px -2px, #00000005 0 -2px 5px 0px;
    }
    &.hint-info {
        border-color: #3884ff;
        background: #f7f5f9;
        box-shadow: #bfbeb9 0px 4px 10px -2px, #00000005 0 -2px 5px 0px;
    }

    .icon {
        margin: 0 1em auto 0;
        text-align: center;
        width: 24px;
        flex-shrink: 0;

        img{
            width: 2em;
            height: 2em;
        }
    }

    .content{
        margin: 0;
        padding: 0;
        line-height: 1.8em;
    }

`